import React from 'react';
import { Button, Divider, Header } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import InformeImprimible from './Componentes/informeImprimible';
import TablaGastosDiarios from './Componentes/TablaGastosDiarios';
import TablaPagosDelDiaPorArea from './Componentes/TablaPagosDelDiaPorArea';
import TablaPagosEventualesDelDia from './Componentes/TablaPagosEventualesDelDia';
import TablaTotalMetodoDePago from './Componentes/TablaTotalMetodoDePago';
import TablaTotalPagosDelDia from './Componentes/TablaTotalPagosDelDia';
import TablaTotalPagosPorArea from './Componentes/TablaTotalPagosPorArea';
import { DatosInformeCobranzasDiario, ListaDeResponsables } from './tipos';

interface InformesProps {
    //
}

interface State {
    informe: DatosInformeCobranzasDiario;
    listaDeResponsables: ReadonlyArray<ListaDeResponsables>;
    cargando: boolean;
    mostrarImprimible: boolean;
}

class Informes extends React.Component<InformesProps, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        informe: {
            informe: {
                totalPagos: {
                    preu: {
                        montoTotal: 0,
                    },
                    ingles: {
                        montoTotal: 0,
                    },
                    otrosPagos: {
                        montoTotal: 0,
                    },
                    pagosCuotasYCobrosCalculados: {
                        montoTotal: 0,
                    },
                    totalPagos: {
                        montoTotal: 0,
                    },
                },
                pagosAsociadosAAreaDelDia: [],
                gastosDiarios: [],
                totalGastosDiarios: 0,
                pagosEventualesDelDia: [],
                totalDeCadaMetodoDePago: {
                    efectivo: 0,
                    tarjetaDebito: 0,
                    tarjetaCredito: 0,
                    cheque: 0,
                    deposito: 0,
                    transferencia: 0,
                    efectivoMenosGastosDiarios: 0,
                },
            },
        },
        listaDeResponsables: [],
        cargando: true,
        mostrarImprimible: false,
    };

    public componentDidMount() {
        this.obtenerInformeCobranzasDiario();
        this.obtenerListaDeResponsables();
    }
    public render() {
        const { cargando, informe } = this.state;

        if (cargando) {
            return <h1>Cargando...</h1>;
        }
        const totalPagosPreu = informe.informe.totalPagos.preu.montoTotal;
        const totalPagosIngles = informe.informe.totalPagos.ingles.montoTotal;
        const totalPagosCuotasYCobrosCalculadosDelDia =
            informe.informe.totalPagos.pagosCuotasYCobrosCalculados.montoTotal;
        const totalOtrosPagos = informe.informe.totalPagos.otrosPagos.montoTotal;
        const totalPagos = informe.informe.totalPagos.totalPagos.montoTotal;
        const totalGastosDiarios = informe.informe.totalGastosDiarios;
        const pagosAsociadosAAreaDelDia = informe.informe.pagosAsociadosAAreaDelDia;
        const gastosDiarios = informe.informe.gastosDiarios;
        const pagosEventualesDelDia = informe.informe.pagosEventualesDelDia;
        const totalDeCadaMetodoDePago = informe.informe.totalDeCadaMetodoDePago;
        return (
            <div>
                <Header as='h2'>Informe financiero diario</Header>
                <Header as='h3' textAlign='right'>
                    {imprimirFecha()}
                </Header>
                <TablaTotalPagosDelDia
                    totalPagosCuotasYCobrosCalculadosDelDia={
                        totalPagosCuotasYCobrosCalculadosDelDia
                    }
                    totalOtrosPagos={totalOtrosPagos}
                    totalPagos={totalPagos}
                />
                <Divider hidden />
                <TablaTotalPagosPorArea
                    totalPagosDelDiaPreu={totalPagosPreu}
                    totalPagosDelDiaIngles={totalPagosIngles}
                    totalPagosCuotasYCobrosCalculadosDelDia={
                        totalPagosCuotasYCobrosCalculadosDelDia
                    }
                />
                <Divider hidden />
                {pagosAsociadosAAreaDelDia.length !== 0 ? (
                    <TablaPagosDelDiaPorArea pagosDelDia={pagosAsociadosAAreaDelDia} />
                ) : (
                    ''
                )}
                <Divider hidden />
                {gastosDiarios.length !== 0 ? (
                    <TablaGastosDiarios
                        gastos={gastosDiarios}
                        totalGastosDiarios={totalGastosDiarios}
                        listaDeResponsables={this.state.listaDeResponsables}
                    />
                ) : (
                    ''
                )}
                <Divider hidden />
                {pagosEventualesDelDia.length !== 0 ? (
                    <TablaPagosEventualesDelDia
                        pagosEventualesDelDia={pagosEventualesDelDia}
                        totalOtrosPagos={totalOtrosPagos}
                    />
                ) : (
                    ''
                )}
                <Divider hidden />
                <TablaTotalMetodoDePago
                    totalEfectivo={totalDeCadaMetodoDePago.efectivo}
                    totalTarjetaDebito={totalDeCadaMetodoDePago.tarjetaDebito}
                    totalTarjetaCredito={totalDeCadaMetodoDePago.tarjetaCredito}
                    totalDeposito={totalDeCadaMetodoDePago.deposito}
                    totalTransferencia={totalDeCadaMetodoDePago.transferencia}
                    totalCheque={totalDeCadaMetodoDePago.cheque}
                    totalEfectivoMenosGastosDiarios={
                        totalDeCadaMetodoDePago.efectivoMenosGastosDiarios
                    }
                />
                <Divider hidden />
                <Button content='Versión para imprimir' onClick={this.mostrarImprimible} />
                {this.state.mostrarImprimible && (
                    <InformeImprimible
                        alCerrar={this.ocultarImprimible}
                        fecha={imprimirFecha()}
                        totalPagosCuotasYCobrosCalculadosDelDia={
                            totalPagosCuotasYCobrosCalculadosDelDia
                        }
                        totalOtrosPagos={totalOtrosPagos}
                        totalPagos={totalPagos}
                        totalPagosDelDiaPreu={totalPagosPreu}
                        totalPagosDelDiaIngles={totalPagosIngles}
                        pagosDelDia={pagosAsociadosAAreaDelDia}
                        gastos={gastosDiarios}
                        totalGastosDiarios={totalGastosDiarios}
                        listaDeResponsables={this.state.listaDeResponsables}
                        pagosEventualesDelDia={pagosEventualesDelDia}
                        totalEfectivo={totalDeCadaMetodoDePago.efectivo}
                        totalTarjetaDebito={totalDeCadaMetodoDePago.tarjetaDebito}
                        totalTarjetaCredito={totalDeCadaMetodoDePago.tarjetaCredito}
                        totalDeposito={totalDeCadaMetodoDePago.deposito}
                        totalTransferencia={totalDeCadaMetodoDePago.transferencia}
                        totalCheque={totalDeCadaMetodoDePago.cheque}
                        totalEfectivoMenosGastosDiarios={
                            totalDeCadaMetodoDePago.efectivoMenosGastosDiarios
                        }
                    />
                )}
            </div>
        );
    }

    private readonly mostrarImprimible = () => {
        this.setState({ mostrarImprimible: true });
    };

    private readonly ocultarImprimible = () => {
        this.setState({ mostrarImprimible: false });
    };

    private readonly obtenerListaDeResponsables = () => {
        clienteApi
            .ejecutar('obtenerListaDeResponsablesDeGastosDiarios')
            .then(listaDeResponsables => {
                this.setState({ listaDeResponsables });
            })
            .catch(this.context.mostrarModalError);
    };

    private readonly obtenerInformeCobranzasDiario = () => {
        clienteApi
            .ejecutar('obtenerInformeCobranzasDiario')
            .then(informe => {
                this.setState({ cargando: false, informe });
            })
            .catch(this.context.mostrarModalError);
    };
}

function imprimirFecha() {
    const nombresDiasDeSemana = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
    ];
    const nombresMeses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];
    const fecha = new Date();
    const numeroDiaDeSemana = fecha.getDay();
    const numeroDiaDelMes = fecha.getDate();
    const numeroMes = fecha.getMonth();
    const año = fecha.getFullYear();

    return (
        nombresDiasDeSemana[numeroDiaDeSemana] +
        ' ' +
        numeroDiaDelMes.toString() +
        ' ' +
        'de ' +
        nombresMeses[numeroMes] +
        ' de ' +
        año.toString()
    );
}

export default Informes;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/index.tsx